import { cn } from '@foam/buoy/src/lib/utils';

interface BrandLogoProps {
  src: string;
  alt: string;
  variant?: 'standard' | 'full';
  onClick?: () => void;
  disabled?: boolean;
}

export const BrandLogo = ({
  src,
  alt,
  variant = 'standard',
  onClick,
  disabled = false,
}: BrandLogoProps) => (
  <div
    className={cn(
      'flex aspect-square size-full items-center justify-center rounded-8 bg-neutral-200 p-2',
      !disabled && 'cursor-pointer hover:bg-neutral-100',
    )}
    onClick={disabled ? undefined : onClick}
  >
    <img
      src={src}
      alt={alt}
      {...(variant === 'standard' && { width: 57, height: 57 })}
      className={cn(
        'object-contain',
        variant === 'full' && 'max-h-16 max-w-full',
      )}
    />
  </div>
);
